export default defineNuxtRouteMiddleware(() => {
  const user = useAuthUser()
  const localePath = useLocalePath()
  if (!user.value || !user.value?.is_staff) {
    return navigateTo(localePath(`/`))
  }
})
